import React from 'react';
import CertificateFinder from './CertificateFinder';

const Home: React.FC = () => {
  return <CertificateFinder />;
};

export default Home;
